import {Box} from '@mui/material';
import {MoreVert} from '@mui/icons-material';
import '../../assets/styles/userCard.scss';
export default function UserAccessCard({
  textUpper,
  textLower,
  avatar,
  onClick,
  withImage = true,
}) {
  return (
    <Box className='user_card_ctr'>
      <Box className='user_card_content' onClick={onClick}>
        {withImage && (
          <img className='user_card_img' src={avatar} alt='card_img' />
        )}
        <div className='user_card_text'>
          <p className='text_upper'>{textUpper}</p>
          <p className='text_lower'>{textLower}</p>
        </div>
      </Box>
      <Box className='user_card_more'>
        <MoreVert htmlColor='#fff' />
      </Box>
    </Box>
  );
}
